export const TRANSACTION_TYPE = {
  REWARD: 'reward',
  REDEEM: 'redeem'
}

export const TRANSACTION_STATUS = {
  PENDING: 'pending',
  SUCCESS: 'success',
  FAILED: 'failed',
  CANCELLED: 'cancelled'
}

export const TRANSACTION_STATUS_LABEL = {
  FUTURE: 'future'
}
